import React, { useEffect } from 'react'
import Loading from '../../components/Loading'
import { connect } from 'react-redux'
import { createFile, getAll, setTitle } from '../../actions'
import Card from '../../components/Card'
import DynamicForm from '../../containers/DynamicForm'
import { useParams } from 'react-router-dom'

const UpdateModel = props => {
  const { setTitle, colors } = props
  const { id } = useParams()

  useEffect(() => {
    const topbar = {
      title: 'Actualizar color',
    }
    setTitle(topbar)
    props.getAll('products/colors', 'GET_COLORS')

    // eslint-disable-next-line
  }, [])

  if (!colors) {
    return <Loading />
  }

  const path = `products/colors/${id}`
  const action = 'UPDATE_COLOR'

  const item = colors.find(i => i.id === parseInt(id))

  const form = [
    {
      id: 1,
      name: 'name',
      label: 'Nombre',
      type: 'text',
      rules: {
        required: 'Este campo es requerido',
      },
      col: 12,
      value: item.name,
    },
  ]

  return (
    <Card title={'Información del color'}>
      <DynamicForm
        path={path}
        action={action}
        form={form}
        edit={true}
      />
    </Card>
  )
}

const mapStateToProps = state => {
  return {
    colors: state.products.colors,
    families: state.products.families,
    models: state.products.models,
  }
}

const mapDispatchToProps = {
  createFile,
  getAll,
  setTitle,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateModel)
